import { FooterAviso } from '@/global/components/DataGrid/components/DataTable/Footer'
import dayjs from 'dayjs'

/** Homologação dura 60 dias a partir da criação do cliente. */
const DIAS_DE_HOMOLOGACAO = 60

/**
 * Aviso do prazo de homologação, usado como `components.Footer` das duas abas.
 * Devolve só o alerta: o `TableFooterContainer` já renderiza a paginação como
 * irmã deste componente.
 */
export default function PrazoHomologacao({
    criadoEm,
}: {
    criadoEm?: string | Date
}) {
    if (!criadoEm) return null

    const limite = dayjs(criadoEm).add(DIAS_DE_HOMOLOGACAO, 'day')
    const diasRestantes = limite.diff(dayjs(), 'day')
    const vencido = diasRestantes < 0

    return (
        <FooterAviso severity={vencido ? 'error' : 'info'}>
            {vencido
                ? `Homologação encerrada em ${limite.format('DD/MM/YYYY')}.`
                : `Homologação termina em ${limite.format(
                      'DD/MM/YYYY',
                  )} (${diasRestantes} dia(s) restante(s)).`}
        </FooterAviso>
    )
}
